import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { SectionWrapper } from './SectionWrapper';

const GitProjects = () => {
    const [repositories, setRepositories] = useState([]);
    const [folders, setFolders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [excludedFolders, setExcludedFolders] = useState(['.github', 'forms', 'webpack']); // Example excluded folders

    useEffect(() => {
        const fetchData = async () => {
            try {
                const owner = 'ksachin7';
                // const repo = 'Projects'; 
                const repoList = ['Projects', 'react-practices']; // Replace with your list of repositories   
                const REACT_APP_GITHUB_TOKEN = `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`;
                const getAllRepos = `https://api.github.com/users/ksachin7/repos`;
                const getProjects = `https://api.github.com/repos/ksachin7/Projects/projects`

                let allFolders = [];

                for (const repo of repoList) {
                    const repoResponse = await axios.get(`https://api.github.com/repos/${owner}/${repo}`, {
                        headers: {
                            'Authorization': `token ${REACT_APP_GITHUB_TOKEN}`
                        }
                    });

                    const contentsResponse = await axios.get(`https://api.github.com/repos/${owner}/${repo}/contents`, {
                        headers: {
                            'Authorization': `token ${REACT_APP_GITHUB_TOKEN}`
                        }
                    });

                    const repoFolders = contentsResponse.data.filter(item => item.type === 'dir' && !excludedFolders.includes(item.name));

                    allFolders = [...allFolders, ...repoFolders.map(folder => ({ ...folder, repo: repoResponse.data.name }))];
                }

                setFolders(allFolders);
            } catch (err) {
                console.error('Error:', err);
                setError('Error fetching data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) return <LoadingMessage>Loading...</LoadingMessage>;
    if (error) return <ErrorMessage>{error}</ErrorMessage>;
    if (folders.length === 0) return <NoProjectsMessage>No projects available.</NoProjectsMessage>;

    return (
        <SectionWrapper>
            <Title>Projects</Title>
            <Description>Displaying folders from selected repositories.</Description>
            <Container>
                <LeftColumn>
                    <Gif src="path_to_your_gif.gif" alt="Projects GIF" />
                </LeftColumn>
                <RightColumn>
                    <ProjectList>
                        {folders.map(folder => (
                            <ProjectCard key={folder.path}>
                                <h3>{folder.name}</h3>
                                <p>{folder.path}</p>
                                <ProjectInfo>
                                    <Info>
                                        <a href={folder.html_url} target="_blank" rel="noopener noreferrer">View on GitHub</a>
                                    </Info>
                                </ProjectInfo>
                            </ProjectCard>
                        ))}
                    </ProjectList>
                    <BlurOverlay />
                </RightColumn>
            </Container>
        </SectionWrapper>
    );
};

// Styled Components

const Container = styled.div`
  display: flex;
  height: 70vh;
  /* background-color: black; */
  color: white;
`;

const LeftColumn = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  /* background-color: #222; */
`;

const Gif = styled.img`
  max-width: 100%;
  height: auto;
  border: 1px solid gray;
`;

const RightColumn = styled.div`
  width: 50%;
  padding: 20px;
  overflow-y: auto;
  position: relative;
`;

const Title = styled.h1`
  font-size: 36px;
  margin-bottom: 10px;
`;

const Description = styled.p`
  font-size: 18px;
  margin-bottom: 20px;
`;

const ProjectList = styled.div`
  position: relative;
`;

const ProjectCard = styled.div`
  /* background: rgba(0, 0, 0, 0.8); */
  border: 1px solid gray;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
  
  h3 {
    margin-top: 0;
  }
  
  p {
    margin: 5px 0;
  }
  
  a {
    color: lightblue;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const ProjectInfo = styled.div`
  margin-top: 10px;
  font-size: 14px;
  color: #ddd;
`;

const Info = styled.div`
  margin: 5px 0;
`;

const BlurOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  /* background: rgba(0, 0, 0, 0.5); */
  backdrop-filter: blur(5px);
`;

const LoadingMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: white;
  font-size: 24px;
`;

const ErrorMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: red;
  font-size: 24px;
`;

const NoProjectsMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: white;
  font-size: 24px;
`;

export default GitProjects;
